export default __webpack_public_path__ + "static/media/SkModernistRegular.748466dc.otf";